import React, { FC } from "react";
import { AnySessionPart, SessionPartKind } from "../session.types";
import { MDSSessionMarkdownV1Part } from "@/mds/components/sessions/session-parts/session-message-markdown-v1-part";
import { MDSSessionReasoningV1Part } from "@/mds/components/sessions/session-parts/session-message-reasoning-v1-part";
import { MDSSessionWebClipV1Part } from "@/mds/components/sessions/session-parts/session-message-web-clip-v1-part";
import { MDSSessionArtifactV1Part } from "@/mds/components/sessions/session-parts/artifacts/session-artifact-v1-part";
import { MDSSessionClientStatusPart } from "@/mds/components/sessions/session-parts/session-client-status-part";
import { SessionPartProps } from "@/mds/components/sessions/session-parts/session-part.types";

type Props = SessionPartProps<AnySessionPart>;

export const MDSSessionPart: FC<Props> = ({ part, ...rest }) => {
  switch (part.kind) {
    case SessionPartKind.MarkdownV1: {
      return <MDSSessionMarkdownV1Part {...rest} part={part} />;
    }
    case SessionPartKind.ReasoningV1: {
      return <MDSSessionReasoningV1Part {...rest} part={part} />;
    }
    case SessionPartKind.InterruptV1: {
      // Note that "Interrupted" parts are also folded into the reasoning groups.
      return <MDSSessionReasoningV1Part {...rest} part={part} />;
    }
    case SessionPartKind.WebClipV1: {
      return <MDSSessionWebClipV1Part {...rest} part={part} />;
    }
    case SessionPartKind.ArtifactV1: {
      return <MDSSessionArtifactV1Part {...rest} part={part} />;
    }
    case SessionPartKind._ClientStatus: {
      return <MDSSessionClientStatusPart {...rest} part={part} />;
    }
    default: {
      return null;
    }
  }
};
